export const AR = {
    title: 'كيف يمكننا مساعدتك',
    content: 'إذا كان لديك أي استفسار، فلا تتردد في طرحه,',
    subContent: 'نحن في خدمتكم',
    res: 'الرد في خلال 48 ساعة.',
}

export const USA = {
    title: 'How can we help you',
    content: 'If you have any questions, please feel free to ask,',
    subContent: 'We are at your service',
    res: 'respond within 48 h.',
}